module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAGFBMVEUAAABBQEJBQEJBQEJBQEJBQEJBQEJBQEIfX4aOAAAAB3RSTlMAIJ/vADAQTXMoVgAAAIhJREFUeF7t1jEKwCAMBVDP0J6gU+dOuYD1BD2JGf71ixmF5jsIRcjfhAeKEvxphWyiR+6SuvUtgD4E7QBwEXQ2VAmShtRHBZYJKC+GAgXaBJ/Rw5ANraMeQzvcXIZOH1VD4iNtqIBkFPHtRg/Or2DwMvmzxCAECsS/fF4eeA2ZUWgyqUZd/kMvcDAD2t3U6h8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2795.png
// module id = 1409
// module chunks = 0